import list from './list';
import detail from '../warehouseAgenciesTransfer/detail';
import edit from "../warehouseAgenciesTransfer/edit";
export default {
    list: list,
    show: detail,
    edit: edit,
    name: "transferrequests",
    key: "p_transferrequests",
}